// removed by extract-text-webpack-plugin
module.exports = {"container":"container_WebsiteMap","block":"block_WebsiteMap","logo":"logo_WebsiteMap","full-link":"full-link_WebsiteMap","fullLink":"full-link_WebsiteMap","link":"link_WebsiteMap"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/HomePageV2/components/WebsiteMap/WebsiteMap.scss
// module id = 123
// module chunks = 0